import { Tag } from 'antd';
import React from 'react';
import { minutesToHour } from '../../../helpers/formatTime';
import classes from './VideoDescription.module.scss';

const VideoDescription = ({ video }) => {
  return (
    <div className={classes['container']}>
      <div className={classes['video-duration']}>
        <div>
          <div>{video.recordDate}</div>
          <div>{minutesToHour(video.minute)}</div>
        </div>
      </div>

      <div className={classes['video-tags']}>
        {video.tags &&
          video.tags.split(';').map((tag) => (
            <Tag key={tag} style={{ margin: 3 }}>
              {tag}
            </Tag>
          ))}
      </div>
    </div>
  );
};

export default VideoDescription;
